import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import BottomNav from "@/components/feature/BottomNav";
import RouteScrollManager from "@/components/feature/RouteScrollManager";
import ApiResultModalHost from "@/components/feature/ApiResultModalHost";
import { AuthProvider } from "@/contexts/AuthContext";

function MainShell() {
  return (
    <>
      <ApiResultModalHost />
      <RouteScrollManager />
      <AppRoutes />
      <BottomNav />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={import.meta.env.BASE_PATH}>
        <MainShell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
